export enum EncryptedExportType {
  AccountEncrypted = 0,
  FileEncrypted = 1,
}
